import { render, staticRenderFns } from "./OMenu.vue?vue&type=template&id=76e22e36"
import script from "./OMenu.vue?vue&type=script&lang=js"
export * from "./OMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports